import { FC, useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHeaderStore } from "../parts/CommonHeader";
import { LoginDialog } from "../parts/LoginDialog";
import { Modal } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { getModalOffset } from "../services/ScreenUtil";
import { Toaster } from "react-hot-toast";

export const SignupPage: FC = () => {
  const [loginDialogOpened, { open: openLoginDialog, close: closeLoginDialog }] = useDisclosure(false);
  const { screenWidth } = useHeaderStore();

  useEffect(() => {
    openLoginDialog();
  }, []);

  function onLoginEvent() {
    window.location.href = '/image-generation'
  }
  
  return <>
    <Helmet>
      <title>アカウント登録 - Drop AI | 無料で使えるAI画像生成ツール</title>
      <meta name="description" content="アカウント登録" />
    </Helmet>
    <Modal size="auto" opened={true}  onClose={closeLoginDialog} closeButtonProps={{ display: 'none' }} overlayProps={{ opacity: 0.0 }} yOffset={getModalOffset(screenWidth)}>
      <LoginDialog onCancel={() => closeLoginDialog()}  onLogin={() => onLoginEvent()} isLogin={false} />
    </Modal>
    <Toaster />
    <div style={{ backgroundImage: 'url(/images/login-background2.png)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: '100%', height: '100vh' }}>
    </div>
  </>;
}